const haveSharedArrayBuffer = typeof globalThis.SharedArrayBuffer === 'function'; // eslint-disable-line
function getTransferable(data) {
    let result = null;
    if (data.buffer !== undefined) {
        result = data.buffer;
    }
    else if (data.byteLength !== undefined) {
        result = data;
    }
    if (!!result && haveSharedArrayBuffer && result instanceof SharedArrayBuffer) { // eslint-disable-line
        return null;
    }
    return result;
}
export default getTransferable;
